export const avalancheZaps = [
  {
    // Pangolin
    zapAddress: '0x7f62aF30081178F502c3d4DA17825e58d240D737',
    ammRouter: '0xE54Ca86531e17Ef3616d22Ca28b0D458b6C89106',
    ammFactory: '0xefa94DE7a4656D787667C749f7E1223D71E9FD88',
    ammPairInitHash: '0x40231f6b438bce0797c9ada29b718a87ea0a5cea3fe9a771abdd76bd41a3e545',
  },
];
